/* eslint import/prefer-default-export: 0 */
import AppIntegrationsRepository from 'common/repositories/-RFC.appIntegrationsRepository';
import DevicesRepository from 'common/repositories/-RFC.devicesRepository';
import TransactionsRepository from 'common/repositories/-RFC.transactionsRepository';
import MeRepository from 'common/repositories/-RFC.meRepository';
import LicensesRepository from 'common/repositories/-RFC.licensesRepository';
import EventsRepository from 'common/repositories/-RFC.eventsRepository';
import GdprActionsRepository from 'common/repositories/-RFC.gdprActionsRepository';
import ActivationCodesRepository from 'common/repositories/-RFC.activationCodesRepository';
import UsersRepository from 'common/repositories/-RFC.usersRepository';
import PaymentTypesRepository from 'common/repositories/-RFC.paymentTypesRepository';
import AppInstancesRepository from 'common/repositories/-RFC.appInstancesRepository';
import RecommendationsRepository from 'common/repositories/-RFC.recommendationsRepository';
import NewsRepository from 'common/repositories/-RFC.newsRepository';
import PaymentUrlsRepository from 'common/repositories/-RFC.paymentUrlsRepository';
import AppPricesRepository from 'common/repositories/-RFC.appPricesRepository';
import GdprReportsRepository from 'common/repositories/-RFC.gdprReportsRepository';
import FlexiblePromotionsRepository from 'common/repositories/-RFC.flexiblePromotionsRepository';
import ExpiredLicensesRepository from 'common/repositories/-RFC.expiredLicensesRepository';
import CryptoRepository from 'common/repositories/-RFC.cryptoRepository';
import dwmRepository from 'common/repositories/-RFC.dwmRepository';

import './actionsRepository';

export {
    AppIntegrationsRepository,
    DevicesRepository,
    TransactionsRepository,
    MeRepository,
    LicensesRepository,
    EventsRepository,
    GdprActionsRepository,
    ActivationCodesRepository,
    UsersRepository,
    PaymentTypesRepository,
    AppInstancesRepository,
    RecommendationsRepository,
    NewsRepository,
    PaymentUrlsRepository,
    AppPricesRepository,
    GdprReportsRepository,
    FlexiblePromotionsRepository,
    ExpiredLicensesRepository,
    CryptoRepository,
    dwmRepository,
};



// WEBPACK FOOTER //
// ./scripts/common/repositories/index.js